export default function CSPFooter({ variant = "app", version = null }) {
  const isLogin = variant === "login";
  return (
    <footer data-testid="csp-footer" className={`w-full ${isLogin ? "text-white/70" : "text-zinc-500"} text-[11px] leading-relaxed`}>
      <div className={`${isLogin ? "" : "border-t border-zinc-200 pt-4 mt-8"} space-y-1`}>
        <div className="font-semibold">A.s.d. Club Scherma Palermo</div>
        <div>Sede legale: Via Adelaide Baviera Albanese, 6 — 90147 Palermo</div>
        <div>Sede operativa: Via Principe di Paternò, 128 — 90144 Palermo</div>
        <div className={`${isLogin ? "text-white/50" : "text-zinc-400"} font-mono pt-1`}>
          © {new Date().getFullYear()} A.s.d. Club Scherma Palermo · Tutti i diritti riservati
          {version && <span data-testid="footer-version"> · CSP Lab v{version}</span>}
        </div>
      </div>
    </footer>
  );
}
